export const textViewBtn = "";
export const textEditBtn = "";
export const textDeleteBtn = "";
// color
export const colorViewBtn = "none";
export const colorEditBtn = "none";
export const colorDeleteBtn = "none";
// icon
export const iconViewBtn = "assets/icons/view.png";
export const iconEditBtn = "assets/icons/edit.png";
export const iconDeleteBtn = "assets/icons/delete.png";
export const iconApproveBtn = "assets/icons/ic-approve.png";
// color shadow hover
export const hoverViewBtn = "none";
export const hoverEditBtn = "none";
export const hoverDeleteBtn = "none";
